import React from 'react';
import classNames from 'classnames';

import LanguageSelectorItem from './language_selector_item.jsx';

class LanguageSelector extends React.Component {
    focusedElementBeforeOpen = null;

    isActiveLanguage = ({ language_tag }) => {
        return language_tag === this.props.current_language_tag;
    }

    state = {
        currentLanguage: this.props.languages.find(this.isActiveLanguage),
        isOpen: false
    };

    handleClick = ({ target }) => {
        if (!(target === this.languageList || this.languageList.contains(target))) {
            this.closeMenu();
        }
    }

    handleButtonKeyDown = event => {
        switch (event.key) {
            case 'Enter':
            case 'ArrowDown':
                event.preventDefault();
                this.openMenu();
                break;
            case 'Escape':
                event.preventDefault();
                this.closeMenu();
                break;
        }
    }

    handleItemKeyDown = event => {
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                this.focusNextElement(event.target);
                break;
            case 'ArrowUp':
                event.preventDefault();
                this.focusPreviousElement(event.target);
                break;
            case 'Escape':
                this.closeMenu();
                break;
        }
    }

    openMenu = () => {
        this.focusedElBeforeOpen = document.activeElement;
        this.setState(() => ({
            isOpen: true
        }), () => {
            this.languageList.children[0].querySelector('a').focus();
            window.addEventListener('click', this.handleClick);
        });
    }

    closeMenu = () => {
        this.setState(() => ({
            isOpen: false
        }), () => {
            window.removeEventListener('click', this.handleClick);
            this.focusedElBeforeOpen.focus();
        });
    }

    focusNextElement = ({ parentElement }) => {
        const nextSiblingElement = parentElement.nextElementSibling;
        if (nextSiblingElement) {
            nextSiblingElement.querySelector('a').focus();
        }
    }

    focusPreviousElement = ({ parentElement }) => {
        const prevSiblingElement = parentElement.previousElementSibling;
        if (prevSiblingElement) {
            prevSiblingElement.querySelector('a').focus();
        }
    }

    render() {
        const languageSelectorClass = classNames('language-selector', { 'language-selector__open': this.state.isOpen });
        return (
            <div className={languageSelectorClass}>
                <button className="language-selector__switch"
                    aria-haspopup="listbox"
                    aria-expanded={this.state.isOpen}
                    aria-label={'Select your language, Currently selected: ' + this.state.currentLanguage.language_name}
                    onKeyDown={this.handleButtonKeyDown}
                >Language: {this.state.currentLanguage.language_name}</button>
                <ul className="language-selector__dropdown"
                    tabIndex="-1"
                    aria-label="Select your language"
                    role="listbox"
                    ref={e => this.languageList = e}
                >
                    {this.props.languages.map((item, i) => (
                        <LanguageSelectorItem
                            key={i}
                            language_name={item.language_name}
                            language_tag={item.language_tag}
                            handleItemKeyDown={this.handleItemKeyDown}
                            {...this.props}
                        />
                    ))}
                </ul>
            </div>
        );
    }
}

export default LanguageSelector;





// WEBPACK FOOTER //
// ./components/navigation/language_selector.jsx